module.exports = __webpack_public_path__ + "img/heart.fa56e076.svg";